import { render, staticRenderFns } from "./RegisteredAccountForm.vue?vue&type=template&id=69070c9a&scoped=true&"
import script from "./RegisteredAccountForm.vue?vue&type=script&lang=js&"
export * from "./RegisteredAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredAccountForm.vue?vue&type=style&index=0&id=69070c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69070c9a",
  null
  
)

export default component.exports